/*
 * @Author: zhujiapeng
 * @Date: 2021-01-22 20:24:21
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-01-30 15:12:09
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
class Permission { 
  constructor() { }

  // 人脸考勤
  userAttendanceFace() {
    return (
      window.userPermissionListCodes.indexOf('1118') !== -1 ||
      window.userPermissionListCodes.indexOf('FaceAttendance') !== -1 ||
      window.userPermissionListCodes.indexOf('StuFaceCheckWork') !== -1
    );
  }

  // 刷卡考勤
  userAttendanceCard() {
    return window.userPermissionListCodes.indexOf('1113') !== -1 || window.userPermissionListCodes.indexOf('CardAttendance') !== -1;
  }

  // 添加、删除考勤记录
  useAddDealAttendance() {
    return window.userPermissionListCodes.indexOf('DealAttendance') !== -1;
  }

  // 查看手机号
  hasEduStudentPhone() {
    return window.userPermissionListCodes.indexOf('EduStudentPhone') !== -1;
  }

}

export default new Permission();
